import Slider from 'react-slick'

import ServiceIcon from './ServiceIcon'
import ArrowButton from './ArrowButton'

import 'slick-carousel/slick/slick.scss'
import 'slick-carousel/slick/slick-theme.scss'
const CustomizedSlider = ({
    activeSlide,
    selectedItemIndex,
    selectedItemSlideIndex,
    slides,
    onServiceClick,
    onSlideChanged,
}) => {
    const controls = slides.length > 1

    const children = slides.map((slide, index) => {
        const activeClass = selectedItemSlideIndex === index ? 'active' : ''
        const classNames = 'row no-gutters justify-content-center'

        const icons = slide.map((service, i) => {
            const isSelected = index === selectedItemSlideIndex && i === selectedItemIndex

            return (
                <ServiceIcon
                    key={i}
                    index={i}
                    item={service}
                    serviceId={service.service}
                    onClick={onServiceClick}
                    selected={isSelected}
                    slideIndex={index}
                />
            )
        })

        return (
            <div className="container-fluid" key={index}>
                <div className={`${classNames} ${activeClass}`}>{icons}</div>
            </div>
        )
    })

    return (
        <Slider
            infinite={false}
            arrows={controls}
            afterChange={onSlideChanged}
            dots={controls}
            initialSlide={activeSlide}
            nextArrow={<ArrowButton role="next" />}
            prevArrow={<ArrowButton role="prev" />}>
            {children}
        </Slider>
    )
}

export default CustomizedSlider
